import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-318">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-300 mb-1.5" data-id="element-319">
            {label}
          </label>}
        <div className="relative" data-id="element-320">
          {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-321">
              {leftIcon}
            </div>}
          <input ref={ref} id={inputId} className={`
              w-full px-4 py-2.5 rounded-xl border bg-[#1a1a1a]
              text-white placeholder:text-gray-600
              transition-all duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
              disabled:bg-[#0a0a0a] disabled:text-gray-600 disabled:cursor-not-allowed
              ${leftIcon ? 'pl-10' : ''}
              ${rightIcon ? 'pr-10' : ''}
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-[#2a2a2a] hover:border-[#333333]'}
              ${className}
            `} {...props} data-id="element-322" />
          {rightIcon && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-323">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="mt-1.5 text-sm text-red-400" data-id="element-324">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-325">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';